/**
 * main-product-default.js
 * Handles section-specific behavior for the default product page.
 * Core functionality (variants, cart, slider) is provided by product.js.
 */

(function () {
  'use strict';

  /**
   * Sync thumbnail active state with the main gallery slider.
   * product.js handles Flickity and variant media switching;
   * this adds the visual selected state to thumbnails in our layout.
   */
  function initThumbnailSync() {
    const section = document.querySelector('.cdh-product');
    if (!section) return;

    const slider = section.querySelector('product-slider');
    const thumbContainer = section.querySelector('.cdh-product__gallery-thumbs');
    if (!slider || !thumbContainer) return;

    const observer = new MutationObserver(function () {
      const activeSlide = slider.querySelector('.product-images__slide.is-selected, .product-images__slide.is-active.flickity-selected');
      if (!activeSlide) return;

      const mediaId = activeSlide.dataset.mediaId;
      if (!mediaId) return;

      thumbContainer.querySelectorAll('.product-thumbnail').forEach(function (thumb) {
        thumb.classList.toggle('is-selected', thumb.id.includes(mediaId.split('-').pop()));
      });
    });

    observer.observe(slider, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initThumbnailSync);
  } else {
    initThumbnailSync();
  }
})();
